import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase, isSupabaseConfigured } from "../../services/supabase";
import Spin from "../../components/common/Spin";
import { T } from "../../styles/GlobalStyles";

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isSupabaseConfigured() || !supabase) {
      navigate("/login", { replace: true });
      return;
    }
    supabase.auth.getSession().then(() => {
      navigate("/", { replace: true });
    });
  }, [navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: T.bg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: 16,
      }}
    >
      <Spin />
      <p style={{ color: T.muted, fontSize: 13, fontStyle: "italic" }}>Je vérifie ta session…</p>
    </div>
  );
}
